'use client';

import { Box, freddyTheme, IconButton, Input, InputAdornment } from '@coolblue-development/freddy';
import { Magnifier } from '@coolblue-development/icons';
import { SEARCH_QUERY_PARAM } from '@utils/constants';
import { useClientUrl } from '@utils/url-generators/useClientUrl';
import { useRouter } from 'next/navigation';
import React, { useState } from 'react';

import { HeaderLink } from '../HeaderLink';

export const Searchbar = () => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const filterPageUrl = useClientUrl('filterPage')!;
  const router = useRouter();

  const executeSearch = (query: string) => {
    if (!query) return;

    const queryString = query.length
      ? `?${new URLSearchParams([[SEARCH_QUERY_PARAM, query]]).toString()}`
      : '';
    router.push(`${filterPageUrl}${queryString}`);
  };

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') {
      e.preventDefault();
      setIsSearchOpen(false);
    }

    if (e.key === 'Enter') {
      executeSearch(searchQuery);
    }
  };

  return (
    <>
      {isSearchOpen ? (
        <Box
          component={'li'}
          sx={{
            input: {
              width: '15rem'
            },
            [freddyTheme.breakpoint.maxWidth('md')]: {
              position: 'absolute',
              width: '100%',
              top: '5%'
            }
          }}
        >
          <Input
            role='search'
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
            onKeyDown={onKeyDown}
            onChange={input => setSearchQuery(input.currentTarget.value)}
            variant='borderless'
            placeholder='Search for...'
            aria-label='Search'
            type='search'
            endAdornment={
              <InputAdornment>
                <IconButton
                  size='large'
                  aria-label='Search'
                  onClick={() => executeSearch(searchQuery)}
                >
                  <Magnifier />
                </IconButton>
              </InputAdornment>
            }
          />
        </Box>
      ) : (
        <HeaderLink onClick={() => setIsSearchOpen(true)}>
          <Magnifier size={24} />
        </HeaderLink>
      )}
    </>
  );
};
